import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/index";//首页
import Search from "@/components/search/list";//搜索列表
import Screen from "@/components/screen/list";//筛选列表
import GoodsDetail from "@/components/goods/detail";//产品详情
import ShoppingCar from "@/components/shopping-car/index";//购物车
import PerSonalLayout from "@/components/personal-info/index";//个人信息
import PerSonalInfo from "@/components/personal-info/personal-info";//个人信息
import MyOrder from "@/components/personal-info/my-order";//我的订单
import MyContract from "@/components/personal-info/my-contract";//我的合同
import MyAddress from "@/components/personal-info/my-address";//收件地址
import MyInstitution from "@/components/personal-info/my-institution";//开票信息
import MyLike from "@/components/personal-info/my-like";//我的收藏
import ContractInfo from "@/components/personal-info/contract-info";//合同详情
import OrderInfo from "@/components/personal-info/order-info";//订单详情
import Login from "@/components/login/login";//登录
import Register from "@/components/login/register";//注册
import ForgetPassword from "@/components/login/forgetPassword";//忘记密码
import Article from "@/components/article";//文章详情
import News from "@/components/news";//最新消息列表
import NewsDetail from "@/components/news/detail";//最新消息详情
import Seckill from "@/components/seckill/index";//秒杀专区
import SeckillList from "@/components/seckill/list";//秒杀活动列表
import store from '@/store'
import { MessageBox } from 'element-ui'

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

let isRouteLoginPrompting = false
function promptLoginAndRedirect(redirectPath) {
  if (isRouteLoginPrompting) return
  isRouteLoginPrompting = true

  const redirect = redirectPath || '/'
  let jumped = false
  const timer = setTimeout(() => {
    jumped = true
    router.push({ name: 'Login', query: { redirect } })
  }, 3000)

  MessageBox.alert('请先登录，3秒后将自动跳转到登录页。', '提示', {
    confirmButtonText: '立即登录',
    showClose: false,
    type: 'warning',
    callback: () => {
      if (!jumped) {
        clearTimeout(timer)
        router.push({ name: 'Login', query: { redirect } })
      }
    }
  }).catch(() => {}).finally(() => {
    // 允许后续再次触发（比如用户取消后又点）
    setTimeout(() => { isRouteLoginPrompting = false }, 500)
  })
}

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
      meta: {
        title: "首页",
        content: {
          keywords: "SYTEST、AFM探针、原子力显微镜探针",
          description: "SYTEST 原子力显微镜探针商城"
        }
      }
    },
    {
      path: "/Seckill",
      name: "Seckill",
      component: Seckill,
      meta: {
        title: "秒杀专区"
      }
    },
    {
      path: "/SeckillList",
      name: "SeckillList",
      component: SeckillList,
      meta: {
        title: "秒杀活动"
      }
    },
    {
      path: "/Screen",
      name: "Screen",
      component: Screen,
      meta: {
        title: "筛选列表"
      }
    },
    {
      path: "/Search",
      name: "Search",
      component: Search,
      meta: {
        title: "搜索结果"
      }
    },
    {
      path: "/GoodsDetail",
      name: "GoodsDetail",
      component: GoodsDetail,
      meta: {
        title: "商品详情"
      }
    },
    {
      path: "/ShoppingCar",
      name: "ShoppingCar",
      component: ShoppingCar,
      meta: {
        title: "购物车"
      }
    },
    {
      path: "/PerSonalLayout",
      name: "PerSonalLayout",
      component: PerSonalLayout,
      children: [
        {
          path: "PerSonalInfo",
          name: "PerSonalInfo",
          component: PerSonalInfo,
          meta: {
            title: "个人信息"
          }
        },
        {
          path: "MyOrder",
          name: "MyOrder",
          component: MyOrder,
          meta: {
            title: "我的订单"
          }
        },
        {
          path: "MyContract",
          name: "MyContract",
          component: MyContract,
          meta: {
            title: "我的合同"
          }
        },
        {
          path: "MyAddress",
          name: "MyAddress",
          component: MyAddress,
          meta: {
            title: "收件地址"
          }
        },
        {
          path: "MyInstitution",
          name: "MyInstitution",
          component: MyInstitution,
          meta: {
            title: "开票信息"
          }
        },
        {
          path: "MyLike",
          name: "MyLike",
          component: MyLike,
          meta: {
            title: "我的收藏"
          }
        },
        {
          path: "OrderInfo/:id",
          name: "OrderInfo",
          component: OrderInfo,
          meta: {
            title: "订单详情"
          }
        },
        {
          path: "ContractInfo/:id",
          name: "ContractInfo",
          component: ContractInfo,
          meta: {
            title: "合同详情"
          }
        },
      ]
    },
    {
      path: "/Login",
      name: "Login",
      component: Login,
      meta: {
        title: "登录"
      }
    },
    {
      path: "/Register",
      name: "Register",
      component: Register,
      meta: {
        title: "注册"
      }
    },
    {
      path: "/ForgetPassword",
      name: "ForgetPassword",
      component: ForgetPassword,
      meta: {
        title: "忘记密码"
      }
    },
    {
      path     : "/Article/:name",
      name     : "Article",
      props    : true,
      component: Article
    },
    {
      path     : "/News",
      name     : "News",
      props    : true,
      component: News
    },
    {
      path     : "/News/:id",
      name     : "NewsDetail",
      props    : true,
      component: NewsDetail
    }
  ]
});

// 路由级登录拦截：未登录访问个人中心/订单相关页面时，不立即跳页
router.beforeEach((to, from, next) => {
  const isLogin = store.getters && store.getters.is_login
  if (!isLogin && to.path && to.path.startsWith('/PerSonalLayout')) {
    promptLoginAndRedirect(to.fullPath)
    next(false)
    return
  }
  next()
})

export default router
